import { render, staticRenderFns } from "./MassiveSimpleDigitalSignatureView.vue?vue&type=template&id=24c8f242&scoped=true&"
import script from "./MassiveSimpleDigitalSignatureView.vue?vue&type=script&lang=js&"
export * from "./MassiveSimpleDigitalSignatureView.vue?vue&type=script&lang=js&"
import style0 from "./MassiveSimpleDigitalSignatureView.vue?vue&type=style&index=0&id=24c8f242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c8f242",
  null
  
)

export default component.exports